import { gql } from '@apollo/client'
import { POST_ITEM_FIELDS_FORLIST, POST_ITEM_USER } from './fragments'

export const GET_TABS = gql`
  fragment AiModelTabFragment on AiModelTab {
    id
    englishName
    icon
    isLeaf
    isRadio
    name
    tabExtra {
      artistImage
      artworkImage
      description
    }
    tabType
  }
  query getTabs {
    aiArtworkResourceModule {
      aiSquareTab {
        tab {
          child {
            child {
              child {
                child {
                  ...AiModelTabFragment
                }
                ...AiModelTabFragment
              }
              ...AiModelTabFragment
            }
            ...AiModelTabFragment
          }
          ...AiModelTabFragment
        }
      }
    }
  }
`

export const SEARCH = gql`
  ${POST_ITEM_FIELDS_FORLIST}
  query search(
    $first: Int
    $endCursor: String
    $param: CopyrightAiTextSearchParam
  ) {
    aiArtworkResourceModule {
      wjAiTextSearch(
        page: { first: $first, after: $endCursor, pattern: CURSOR }
        param: $param
      ) {
        edges {
          node {
            ...postItemFieldsForList
            type
            ... on SquarePost {
              #是否被推荐
              recommend
            }
          }
        }
        pageInfo {
          hasNextPage
          totalCount
          endCursor
        }
      }
    }
  }
`

export const GET_HOT_KEYWORD = gql`
  query getHotKeyword {
    aiArtworkResourceModule {
      hotKeywordList
    }
  }
`

export const IMAGE_SEARCH_PAGE = gql`
  ${POST_ITEM_FIELDS_FORLIST}
  ${POST_ITEM_USER}
  query imageSearchImage($offset: Int, $first: Int, $imageUrl: String) {
    aiArtworkResourceModule {
      imageSearchPage(
        page: { first: $first, offset: $offset }
        imageUrl: $imageUrl
      ) {
        edges {
          node {
            ...postItemFieldsForList
            ... on SquarePost {
              user {
                ...postItemUser
              }
            }
          }
        }
        pageInfo {
          hasNextPage
        }
      }
    }
  }
`

export const GET_SIZES = gql`
  query getSizes {
    aiArtworkResourceModule {
      sizeList
    }
  }
`

export const GET_ARTWORK_MODELS = gql`
  query getArtworkModels($model: AiCreateArtworkModel) {
    aiArtworkResourceModule {
      modelClassificationList(aiArtworkModel: $model) {
        id
        name: showName
      }
    }
  }
`
export const GET_VISIBLE_LIST = gql`
  query getVisibleList {
    squareModule {
      postVisibleTypeList {
        desc
        value
      }
    }
  }
`

/** 获取banner */
export const GET_HOME_BANNER_LIST = gql`
  query getHomeBannerList($scene: Int) {
    marketingModule {
      bannerList(scene: $scene) {
        id
        title
        redirectUrl
        imageUrl
        startDateTime: startTime
      }
    }
  }
`
